export default {
  // 对话框标题
  dialogTitle: "添加模型验证地址",

  // 表单标签
  modelType: "模型类型:",
  blockchain: "公链:",
  caseName: "案件名称:",
  address: "地址:",

  // 占位符
  selectModelType: "请选择模型类型",
  selectBlockchain: "请选择公链",
  selectCaseName: "请选择案件名称",
  inputAddress: "请输入地址",

  // 模型类型
  firstFeeFeeModel: "首笔手续费模型",
  relatedFeeModel: "关联手续费模型",
  tornadoModel: "龙卷风模型",

  // 按钮
  reset: "重置",
  add: "添加",

  // 警告提示
  warningInfo:
    "支持批量地址验证，批量地址输入格式请注意，地址与地址之间增加空格或者折行",

  // 表单验证
  inputAddressRequired: "请输入地址",
  selectModelTypeRequired: "请选择模型类型",
  selectBlockchainRequired: "请选择公链",
  selectCaseNameRequired: "请选择案件名称",

  // 消息提示
  professionalFeature: "当前功能仅专业版用户可用，请联系客服咨询。",
  submitSuccess: "提交成功请等待结果",
  addModelSuccess: "添加模型验证成功",
  tip: "提示",
  confirm: "确定",
  cancel: "取消",
};
